import api from "@/services/api"
import type { MaybeRef } from "@vueuse/core"
import { unref } from "vue"
import { useQuery } from "@tanstack/vue-query"
import { BASE_Z_REPORTS_QUERY_KEY } from "../queryKeys"
import type {
  PaginatedResponse,
  PaginationQuery,
} from "../sharedTypes/pagination"
import type { RecursivelyConvertDatesToStrings } from "@/utils/typeUtilities"

export type ListZReportsFilter = {
  reportDate: string | null
}

export type ListZReportsQuery = ListZReportsFilter &
  PaginationQuery

export type ListZReportsResponseItem = {
  id: string
  createdAt: Date
  fromReceiptNo: string | null
  toReceiptNo: string | null
  totalCount: number | null
  totalAmount: number | null
}

const listZReports = async (
  query?: ListZReportsQuery
): Promise<PaginatedResponse<ListZReportsResponseItem>> => {
  const { body } = await api.get<
    RecursivelyConvertDatesToStrings<
      PaginatedResponse<ListZReportsResponseItem>
    >
  >("/devices/z-report-history", {
    query,
  })

  return {
    ...body,
    items: body.items.map((zReport) => ({
      ...zReport,
      createdAt: DateFns.parseISO(zReport.createdAt),
    })),
  }
}

export const useZReports = (
  query: MaybeRef<ListZReportsQuery>
) =>
  useQuery(
    [BASE_Z_REPORTS_QUERY_KEY, query] as const,
    ({ queryKey: [_key, _query] }) =>
      listZReports(unref(_query))
  )
